import React, {useContext, useEffect, useState} from "react"

import Button from "../../../../common/Button";
import {api} from "../../../../../api/api";
import {getErrorByStatus, prepPhone} from "../../helpers";
import BarCDTicker from "../../CountDownTicker/Bar";
import CircleCDTicker from "../../CountDownTicker/Circle"
import BuilderContext from "../../../../../context/BuilderContext";
import TranslationContext from "../../../../../context/TranslationContext";
import UserContext from "../../../../../context/UserContext";


const CallAction = ({handlerBackBtn, setAccess}) => {
    const { style } = useContext(BuilderContext)
    const {getTranslation} = useContext(TranslationContext)
    const {setApiWait} = useContext(UserContext)

    const [progress, setProgress] = useState(100)
    const [gatePhone, setGatePhone] = useState("")
    const [error, setError] = useState('')
    const [errorMsg, setErrorMsg] = useState('')

    const specialHandlerBackBtn = () => {
        localStorage.removeItem("_wh_call")
        handlerBackBtn()
    }

    const runCheckBackground = () => {
        let timer = setInterval(() => {
            if (error !== "") {
                setProgress(0)
                return () => clearInterval(timer)
            }
            setProgress((prevProgress) => {
                return prevProgress <= 0 ? 0 : prevProgress - 1
            })
            return () => clearInterval(timer)
        }, 1000)
    }

    const goCheck = () => {
        api.getCheckCallAuth().then(res => {
            if (res.data.status === "ready" || res.data.status === "ok") {
                localStorage.removeItem("_wh_call")
                setAccess(true)
            }
        }).catch(err => {
            getErrorByStatus(err.response.status, setError, getTranslation)
        }).finally(() => setApiWait(false))
    }

    useEffect(() => {
        if (error !== "") {
            if (getTranslation(error)!=="") {setErrorMsg(getTranslation(error))} else {setErrorMsg(error)}  
        }
    },[getTranslation, error])

    useEffect(() => {
        if (progress < 90 && progress && error === "") {
            goCheck()
            if (progress <= 1 && error === "") {
                setProgress(0)
                handlerBackBtn()
            }
        }
    }, [progress, handlerBackBtn, error, getTranslation, setApiWait, setAccess])

    useEffect(() => {
        setApiWait(true)
        api.getGate().then(res => {
            setProgress(res.data.timeout)
            setGatePhone(res.data.gate)
            localStorage.setItem("_wh_call", JSON.stringify({gate: res.data.gate, type: 499, expire: Date.now()/1000 + res.data.timeout}))
            if (res.data.status === "complete") {
                goCheck()
                return
            }
            runCheckBackground()
        }).catch(err => {
            getErrorByStatus(err.response.status, setError, getTranslation)
        }).finally(() => setApiWait(false))
    },[])


    return (
        <>
            {
                (error === "" && gatePhone!=="")
                    ? <>
                        <span data-id_phrase="mess_call1" >{getTranslation("mess_call1")}</span>
                        <p>
                            <a
                                className="btn element-border"
                                href={`tel:+${gatePhone}`}
                            >+{prepPhone(gatePhone)}</a>
                        </p>
                        <span data-id_phrase="mess_call2">{getTranslation("mess_call2")}</span>
                        <br/>
                        {
                            style.timer_style === "bar"
                            ? <BarCDTicker progress={progress} />
                            : <CircleCDTicker progress={progress} onComplete={()=>setProgress(0)} colorCirlce = {style.color_btn} /> 
                        }
                        <div className={"mt-2"}>
                            <Button
                                onClick={specialHandlerBackBtn}
                                text={"Отмена"}
                                idPhrase={"cancel"}
                            />
                        </div>

                    </>
                    : <>
                        <p data-id_phrase={error}>{errorMsg}</p>
                        <Button
                            onClick={specialHandlerBackBtn}
                            text={"Назад"}
                            idPhrase={"back"}
                        />
                    </>
            }
        </>
    )
}

export default CallAction